import * as Yup from "yup";

const initialValuesReviewTicket = {
    succes_support: "",
    not_success_support_comment:"",
    support_fast_response: "",
    politely_support: "",
    pleasure_support: "",
    comment: ""
}

const validationSchemaReviewTicket = Yup.object().shape({
    succes_support: Yup.string().required('Por favor completar este campo.'),
    not_success_support_comment: Yup.string(),
    support_fast_response: Yup.string().required("Por favor completar este campo."),
    politely_support: Yup.string().required("Por favor completar este campo."),
    pleasure_support: Yup.string().required("Por favor completar este campo."),
    comment: Yup.string()
})

export { validationSchemaReviewTicket, initialValuesReviewTicket }